import {
  getMediaTypeFromProduct,
  MEDIA_TYPES,
} from "./mediaCalculations";

const MEDIA_HOARDING_DIGITAL_SUBCATEGORY_IDS = new Set([
  "643cdf01779bc024c189cf95",
  "65029534eaa5251874e8c6b6",
  "650296faeaa5251874e8c716",
]);

const ADMIN_BW_MARKETPLACE = "/admindashboard/bw-marketplace";

const normalizeValue = (value) => (typeof value === "string" ? value.trim() : value);

export const isMultiplexMedia = (product) =>
  normalizeValue(product?.ProductCategoryName) === "Multiplex ADs";

export const isDigitalOrHoardingMedia = (product) => {
  const subCategoryName = normalizeValue(
    product?.ProductSubCategoryName || product?.productSubCategoryName || "",
  );
  const categoryName = normalizeValue(
    product?.ProductCategoryName || product?.productCategoryName || "",
  );
  return (
    MEDIA_HOARDING_DIGITAL_SUBCATEGORY_IDS.has(product?.ProductSubCategory) ||
    subCategoryName === "Hoardings" ||
    subCategoryName === "Digital ADs" ||
    subCategoryName === "LED OOH" ||
    subCategoryName === "DOOH" ||
    categoryName === "DOOH"
  );
};

export const isMediaProduct = (product) => {
  const listingType = normalizeValue(product?.ListingType || product?.listingType);
  if (listingType === "Media") return true;
  if (product?.ProductSubCategory === "Media") return true;
  if (product?.ProductSubCategoryName === "Media") return true;
  const categoryName = normalizeValue(product?.ProductCategoryName);
  if (categoryName === "MediaOnline" || categoryName === "MediaOffline") return true;
  return false;
};

export const getAdminMediaBuyingPath = (product) => {
  const id = product?._id || product?.id;
  if (!id) return ADMIN_BW_MARKETPLACE;

  const type = getMediaTypeFromProduct(product);

  switch (type) {
    case MEDIA_TYPES.MULTIPLEX:
      return `${ADMIN_BW_MARKETPLACE}/multiplexmediabuying/${id}`;
    case MEDIA_TYPES.HOARDING:
      return `${ADMIN_BW_MARKETPLACE}/hoardingmediabuying/${id}`;
    case MEDIA_TYPES.DOOH:
      return `${ADMIN_BW_MARKETPLACE}/doohmediabuying/${id}`;
    case MEDIA_TYPES.PRINT_MEDIA:
      return `${ADMIN_BW_MARKETPLACE}/printmediabuying/${id}`;
    case MEDIA_TYPES.AIRPORT:
      return `${ADMIN_BW_MARKETPLACE}/airportmediabuying/${id}`;
    case MEDIA_TYPES.TELEVISION:
    case MEDIA_TYPES.RADIO:
    case MEDIA_TYPES.OFFLINE_BTL:
    case MEDIA_TYPES.OTHER:
    default:
      return `${ADMIN_BW_MARKETPLACE}/mediabuying/${id}`;
  }
};

export const MULTIPLEX_MEDIA_SUBCATEGORY_ID = "643cda0c53068696706e3951";

const ADMIN_MARKETPLACE_PREVIEW_BASE = "/admindashboard/marketplace";

export const getAdminMarketplacePreviewPath = (product) => {
  const id = product?._id || product?.id;
  if (!id) return null;

  const listingType = normalizeValue(product?.ListingType || product?.listingType) || "Product";
  const voucherType = product?.VoucherType;
  const productSubCategory = product?.ProductSubCategory;

  if (listingType === "Voucher") {
    const isValueOrGift =
      voucherType === "Value Voucher / Gift Cards " ||
      productSubCategory === "Value Voucher" ||
      productSubCategory === "Gift Cards";
    return isValueOrGift
      ? `${ADMIN_MARKETPLACE_PREVIEW_BASE}/valueandgiftvoucher/${id}`
      : `${ADMIN_MARKETPLACE_PREVIEW_BASE}/spacificvoucher/${id}`;
  }

  if (listingType === "Media") {
    const isMultiplexRoute =
      productSubCategory === MULTIPLEX_MEDIA_SUBCATEGORY_ID || isMultiplexMedia(product);
    if (isMultiplexRoute) {
      return `${ADMIN_MARKETPLACE_PREVIEW_BASE}/multiplexmediaviewproduct/${id}`;
    }
    const mediaType = getMediaTypeFromProduct(product);
    if (mediaType === MEDIA_TYPES.HOARDING || mediaType === MEDIA_TYPES.DOOH) {
      return `${ADMIN_MARKETPLACE_PREVIEW_BASE}/hoardingmediaviewproduct/${id}`;
    }
    return `${ADMIN_MARKETPLACE_PREVIEW_BASE}/mediaviewproduct/${id}`;
  }

  return `${ADMIN_MARKETPLACE_PREVIEW_BASE}/viewproduct/${id}`;
};

